import ApiFetch from 'utils/apiFetch';
import { preparePath } from 'utils/preparePath';

const ApiFetchInstance = ApiFetch();

export const URLS = {
  start: '/digital-loan/start',
  validateBlackList: '/digital-loan/validate-black-list',
  validateCoordinates: '/digital-loan/validate-coordinates/:cp',
  questionnaire: '/digital-loan/:applicationId/questionnaire',
  families: '/digital-loan/families',
  subFamilies: '/digital-loan/sub-families',
  articles: '/digital-loan/articles',
  branches: '/digital-loan/branches',
  models: '/digital-loan/models',
  guarantee: '/digital-loan/:applicationId/guarantee',
  amountAndScoring: '/digital-loan/:applicationId/amount-and-scoring',
  calculateNewLoanAmount: '/digital-loan/:applicationId/calculate-new-loan-amount',
  status: '/digital-loan/status',
  preapproval: '/digital-loan/:applicationId/preapproval',
  scheduleVisit: '/digital-loan/:applicationId/schedule-visit',
  rescheduleVisit: '/digital-loan/:applicationId/reschedule-visit',
  cancelVisit: '/digital-loan/:applicationId/cancel-visit',
  loanTerms: '/digital-loan/loan-terms',
  offer: '/digital-loan/:applicationId/offer',
  acceptOffer: '/digital-loan/:applicationId/offer/accept',
  rejectOffer: '/digital-loan/:applicationId/offer/reject',
  clabe: '/digital-loan/:applicationId/clabe',
  biometricFinal: '/digital-loan/:applicationId/biometric-final',
  contract: '/digital-loan/:applicationId/contract',
  contractDocument: '/digital-loan/:applicationId/contract/documents',
  simulationDocument: '/digital-loan/:applicationId/simulation/documents',
  businessCalendar: '/digital-loan/business-calendar',
};

export default {
  startApplication(consents) {
    return ApiFetchInstance.post(URLS.start, consents);
  },
  checkBlackList(applicationId) {
    return ApiFetchInstance.get(
      preparePath(URLS.validateBlackList, {}, { applicationId }),
    );
  },
  validateCoordinates(postalCode, applicationId, coordinates) {
    return ApiFetchInstance.post(
      preparePath(
        URLS.validateCoordinates,
        { cp: postalCode },
        { applicationId },
      ),
      coordinates,
    );
  },
  submitQuestionnaire(applicationId, formData) {
    return ApiFetchInstance.post(
      preparePath(URLS.questionnaire, { applicationId }),
      formData,
    );
  },
  getFamilies() {
    return ApiFetchInstance.get(URLS.families);
  },
  getSubFamilies({ claveFamilia }) {
    return ApiFetchInstance.get(
      preparePath(URLS.subFamilies, {}, { claveFamilia }),
    );
  },
  getArticles({ idFamiliaSubFamilia }) {
    return ApiFetchInstance.get(
      preparePath(URLS.articles, {}, { idFamiliaSubFamilia }),
    );
  },
  getBranches({ idFamiliaSubFamilia, idSubFamiliaTipoArticulo }) {
    return ApiFetchInstance.get(
      preparePath(URLS.branches, {}, {
        idFamiliaSubFamilia,
        idSubFamiliaTipoArticulo,
      }),
    );
  },
  getModels({
    idMarca,
    idTipoArticulo,
    idSubfamiliaTipoArticulo,
    idFamiliaSubFamilia,
  }) {
    return ApiFetchInstance.get(
      preparePath(URLS.models, {}, {
        idMarca,
        idTipoArticulo,
        idSubfamiliaTipoArticulo,
        idFamiliaSubFamilia,
      }),
    );
  },
  submitGuarantee(applicationId, formData) {
    return ApiFetchInstance.post(
      preparePath(URLS.guarantee, { applicationId }),
      formData,
    );
  },
  runAmountAndScoring(applicationId) {
    return ApiFetchInstance.post(
      preparePath(URLS.amountAndScoring, { applicationId }),
    );
  },
  calculateNewLoanAmount(applicationId, body) {
    return ApiFetchInstance.post(
      preparePath(URLS.calculateNewLoanAmount, { applicationId }),
      body,
    );
  },
  getStatus() {
    return ApiFetchInstance.get(URLS.status);
  },
  acceptPreapproval(applicationId, body) {
    return ApiFetchInstance.post(
      preparePath(URLS.preapproval, { applicationId }),
      body,
    );
  },
  scheduleVisit(applicationId, body) {
    return ApiFetchInstance.post(
      preparePath(URLS.scheduleVisit, { applicationId }),
      body,
    );
  },
  rescheduleVisit(applicationId, body) {
    return ApiFetchInstance.post(
      preparePath(URLS.rescheduleVisit, { applicationId }),
      body,
    );
  },
  cancelVisit(applicationId, body = {}) {
    return ApiFetchInstance.post(
      preparePath(URLS.cancelVisit, { applicationId }),
      body,
    );
  },
  getLoanTerms() {
    return ApiFetchInstance.get(URLS.loanTerms);
  },
  getOffer(applicationId, query = {}) {
    const params = {};
    if (query.plazo != null && query.plazo !== '') {
      params.plazo = query.plazo;
    }
    if (query.periodicidad) {
      params.periodicidad = query.periodicidad;
    }
    const path = preparePath(URLS.offer, { applicationId });
    if (!Object.keys(params).length) {
      return ApiFetchInstance.get(path);
    }
    return ApiFetchInstance.get(path, { params });
  },
  acceptOffer(applicationId, body) {
    return ApiFetchInstance.post(
      preparePath(URLS.acceptOffer, { applicationId }),
      body,
    );
  },
  rejectOffer(applicationId) {
    return ApiFetchInstance.post(
      preparePath(URLS.rejectOffer, { applicationId }),
    );
  },
  captureClabe(applicationId, body) {
    return ApiFetchInstance.post(
      preparePath(URLS.clabe, { applicationId }),
      body,
    );
  },
  getClabe(applicationId) {
    return ApiFetchInstance.get(
      preparePath(URLS.clabe, { applicationId }),
    );
  },
  registerBiometricFinal(applicationId, body) {
    return ApiFetchInstance.post(
      preparePath(URLS.biometricFinal, { applicationId }),
      body,
    );
  },
  generateContract(applicationId) {
    return ApiFetchInstance.post(
      preparePath(URLS.contract, { applicationId }),
    );
  },
  getContractDocument(applicationId, tipo) {
    return ApiFetchInstance.get(
      preparePath(URLS.contractDocument, { applicationId }, { tipo }),
    );
  },
  getSimulationDocument(applicationId, tipo = '') {
    if (String(tipo) === '01') {
      throw new Error('El mutuo solo existe después del contrato');
    }
    return ApiFetchInstance.get(
      preparePath(URLS.simulationDocument, { applicationId }, { tipo }),
    );
  },
  getBusinessCalendar() {
    return ApiFetchInstance.get(URLS.businessCalendar);
  },
};
